import * as React from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import LinkListItem from './Item';

import MasonryGrid from '../../MasonryGrid';
import Slider from '../../Slider';

import './style.scss';

interface LinkListSubComponents {
  Item: typeof LinkListItem;
}

interface LinkListProps {
  children?: React.ReactNode;
}

const LinkList: React.FC<LinkListProps> & LinkListSubComponents = (props) => {
  const { children } = props;

  return (
    <div className="LinkListHomepage">
      <div className="LinkListHomepage__sliderwrapper">
        <Slider>
          {children}
        </Slider>
      </div>
      <div className="LinkListHomepage__gridwrapper">
        <Container>
          {/* @ts-ignore */}
          <MasonryGrid items={children} />
        </Container>
      </div>
    </div>
  );
};

LinkList.Item = LinkListItem;

export default LinkList;
